/**
 * Horizontal Infinite Slider
 * A lightweight, responsive horizontal slider with infinite scrolling
 *
 * Features:
 * - Infinite loop scrolling
 * - Parallax effect on images
 * - Touch and mouse support
 * - Hover-based scroll detection
 * - Responsive design
 * - Smooth animations
 */

// Configuration
const config = {
  SCROLL_SPEED: 1.75,
  LERP_FACTOR: 0.05,
  MAX_VELOCITY: 150,
};

// State management
const state = {
  currentX: 0,
  targetX: 0,
  slideWidth: 370,
  slides: [],
  isDragging: false,
  startX: 0,
  lastX: 0,
  lastMouseX: 0,
  lastScrollTime: Date.now(),
  isMoving: false,
  velocity: 0,
  lastCurrentX: 0,
  dragDistance: 0,
  hasActuallyDragged: false,
  isMobile: false,
  sliderData: [], // Will be set by user
  totalSlideCount: 0,
  /** Detalhe blog garden: overflow-x nativo + scroll-snap (como privacy no contato) */
  blogGardenNative: false,
  blogGardenSizeSlides: null,
};

// Utility functions
function checkMobile() {
  state.isMobile = window.innerWidth < 1000;
}

function createSlideElement(index) {
  const dataIndex = index % state.totalSlideCount;

  // Create the slide as an anchor tag
  const slide = document.createElement("a");
  slide.className = "slide";
  slide.href = state.sliderData[dataIndex].url || "#";

  if (state.isMobile) {
    slide.style.maxWidth = "none";
    slide.style.maxHeight = "none";
    if (state.blogGardenNative) {
      slide.style.width = "";
      slide.style.height = "";
    } else if (document.body.classList.contains("blog-garden-mobile")) {
      slide.style.width = "75vw";
      slide.style.height = "";
    } else {
      slide.style.width = "75vw";
      slide.style.height = "450px";
    }
  }

  const imageContainer = document.createElement("div");
  imageContainer.className = "slide-image";

  const img = document.createElement("img");
  img.src = state.sliderData[dataIndex].img;
  img.alt = state.sliderData[dataIndex].title || "";

  const overlay = document.createElement("div");
  overlay.className = "slide-overlay";

  const title = document.createElement("p");
  title.className = "project-title";
  title.textContent = state.sliderData[dataIndex].title || "";
  overlay.appendChild(title);
  // Add meta text if belowText exists - BEFORE title
  if (state.sliderData[dataIndex].belowText) {
    const meta = document.createElement("p");
    meta.className = "project-meta";
    meta.textContent = state.sliderData[dataIndex].belowText;
    overlay.appendChild(meta);
  }


  // Handle click to prevent navigation if it was a drag
  slide.addEventListener("click", (e) => {
    if (state.dragDistance >= 10 || state.hasActuallyDragged) {
      e.preventDefault();
    }
  });

  imageContainer.appendChild(img);
  slide.appendChild(imageContainer);
  slide.appendChild(overlay);

  return slide;
}

function initializeSlides() {
  const track = document.querySelector(".blog-slider .slide-track");
  if (!track) return;

  track.innerHTML = "";
  state.slides = [];

  checkMobile();

  const tempSlide = createSlideElement(0);
  track.appendChild(tempSlide);

  state.slideWidth = getRealSlideWidth(tempSlide);

  const viewportWidth = window.innerWidth;
  const minWidthNeeded = viewportWidth * 3;

  const slidesPerSequence = state.totalSlideCount;
  const singleSequenceWidth = slidesPerSequence * state.slideWidth;

  const copies = Math.ceil(minWidthNeeded / singleSequenceWidth) + 2;

  track.innerHTML = "";
  state.slides = [];

  const totalSlides = state.totalSlideCount * copies;

  for (let i = 0; i < totalSlides; i++) {
    const slide = createSlideElement(i);
    track.appendChild(slide);
    state.slides.push(slide);
  }

  const startOffset = -(state.totalSlideCount * state.slideWidth * 2);
  state.currentX = startOffset;
  state.targetX = startOffset;

  state.copies = copies;
}

function getRealSlideWidth(slide) {
  const styles = getComputedStyle(slide);
  return (
    slide.getBoundingClientRect().width +
    parseFloat(styles.marginLeft) +
    parseFloat(styles.marginRight)
  );
}


function updateSlidePositions() {
  const track = document.querySelector(".slide-track");
  if (!track) return;

  const sequenceWidth = state.slideWidth * state.totalSlideCount;

  const maxOffset = -sequenceWidth * (state.copies - 1);
  const minOffset = -sequenceWidth;

  if (state.currentX < maxOffset) {
    state.currentX += sequenceWidth;
    state.targetX += sequenceWidth;
  }

  if (state.currentX > minOffset) {
    state.currentX -= sequenceWidth;
    state.targetX -= sequenceWidth;
  }

  track.style.transform = `translate3d(${state.currentX}px, 0, 0)`;
}

function updateParallax() {
  // Parallax effect removed - no transform needed
}

function updateMovingState() {
  state.velocity = Math.abs(state.currentX - state.lastCurrentX);
  state.lastCurrentX = state.currentX;

  const isSlowEnough = state.velocity < 0.1;
  const hasBeenStillLongEnough = Date.now() - state.lastScrollTime > 200;
  state.isMoving =
    state.hasActuallyDragged || !isSlowEnough || !hasBeenStillLongEnough;

  document.documentElement.style.setProperty(
    "--slider-moving",
    state.isMoving ? "1" : "0"
  );
}

function animate() {
  if (state.blogGardenNative) return;

  state.currentX += (state.targetX - state.currentX) * config.LERP_FACTOR;

  updateMovingState();
  updateSlidePositions();
  updateParallax();

  requestAnimationFrame(animate);
}

// Event handlers
let touchStartY = 0;

function handleWheel(e) {
  // Disable wheel scrolling - only allow drag/grabbing
  return;
}

function handleTouchStart(e) {
  state.isDragging = true;
  state.startX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
  state.lastX = state.targetX;
  state.dragDistance = 0;
  state.hasActuallyDragged = false;
  state.lastScrollTime = Date.now();

  // Add visual feedback for touch dragging
  document.body.style.userSelect = 'none';
}

function handleTouchMove(e) {
  if (!state.isDragging) return;

  const clientX = e.touches[0].clientX;
  const clientY = e.touches[0].clientY;
  const rawDx = clientX - state.startX;
  const rawDy = clientY - touchStartY;

  if (
    document.body.classList.contains("blog-garden-mobile") &&
    document.getElementById("blog-garden-detail")
  ) {
    if (Math.abs(rawDy) > Math.abs(rawDx) + 12) {
      state.isDragging = false;
      document.body.style.userSelect = "";
      return;
    }
  }

  const deltaX = rawDx * 1.5;
  state.targetX = state.lastX + deltaX;
  state.dragDistance = Math.abs(deltaX);

  if (state.dragDistance > 5) {
    state.hasActuallyDragged = true;
  }

  state.lastScrollTime = Date.now();
}

function handleTouchEnd() {
  state.isDragging = false;

  // Reset visual feedback
  document.body.style.userSelect = '';

  setTimeout(() => {
    state.hasActuallyDragged = false;
  }, 100);
}

function handleMouseDown(e) {
  e.preventDefault();
  state.isDragging = true;
  state.startX = e.clientX;
  state.lastMouseX = e.clientX;
  state.lastX = state.targetX;
  state.dragDistance = 0;
  state.hasActuallyDragged = false;
  state.lastScrollTime = Date.now();

  // Add visual feedback for dragging
  document.body.style.cursor = 'grabbing';
  document.body.style.userSelect = 'none';
}

function handleMouseMove(e) {
  if (!state.isDragging) return;

  e.preventDefault();
  const deltaX = (e.clientX - state.lastMouseX) * 2;
  state.targetX += deltaX;
  state.lastMouseX = e.clientX;
  state.dragDistance += Math.abs(deltaX);

  if (state.dragDistance > 5) {
    state.hasActuallyDragged = true;
  }

  state.lastScrollTime = Date.now();
}

function handleMouseUp() {
  state.isDragging = false;

  // Reset visual feedback
  document.body.style.cursor = '';
  document.body.style.userSelect = '';

  setTimeout(() => {
    state.hasActuallyDragged = false;
  }, 100);
}

/** Evita reinício do carrossel ao mostrar/ocultar barra do browser no mobile. */
let blogSliderLastResizeWidth = null;

function handleResize() {
  if (state.blogGardenNative && state.blogGardenSizeSlides) {
    const w = window.innerWidth;
    if (
      blogSliderLastResizeWidth !== null &&
      Math.abs(w - blogSliderLastResizeWidth) < 48
    ) {
      return;
    }
    blogSliderLastResizeWidth = w;
    state.blogGardenSizeSlides();
    return;
  }
  blogSliderLastResizeWidth = window.innerWidth;
  initializeSlides();
}

/**
 * Blog detalhe (garden mobile): mesmo padrão do privacy no contato — scroll horizontal
 * nativo, scroll-snap no CSS, sem transform/RAF (não corta nem conflita com o vertical).
 */
function initializeSlidesBlogGardenNative() {
  const track = document.querySelector(".blog-slider .slide-track");
  const slider = document.querySelector(".blog-slider");
  if (!track || !slider) return;

  track.innerHTML = "";
  state.slides = [];
  checkMobile();
  state.blogGardenNative = true;

  for (let i = 0; i < state.totalSlideCount; i++) {
    const slide = createSlideElement(i);
    track.appendChild(slide);
    state.slides.push(slide);
  }
  track.style.transform = "";

  let scrollLeftAtTouch = 0;
  let blockClickFromScroll = false;

  function sizeSlides() {
    const w = slider.clientWidth || 0;
    if (!w) return;
    state.slides.forEach((s) => {
      s.style.flexShrink = "0";
      s.style.flexGrow = "0";
      s.style.flexBasis = `${w}px`;
      s.style.width = `${w}px`;
      s.style.maxWidth = `${w}px`;
    });
  }

  state.blogGardenSizeSlides = sizeSlides;
  sizeSlides();
  requestAnimationFrame(() => {
    sizeSlides();
  });

  slider.addEventListener(
    "touchstart",
    () => {
      scrollLeftAtTouch = slider.scrollLeft;
      blockClickFromScroll = false;
    },
    { passive: true },
  );

  slider.addEventListener(
    "touchend",
    () => {
      blockClickFromScroll = Math.abs(slider.scrollLeft - scrollLeftAtTouch) > 14;
    },
    { passive: true },
  );

  state.slides.forEach((slide) => {
    slide.addEventListener("click", (e) => {
      if (blockClickFromScroll) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
}

let blogSliderListenersAttached = false;
let blogSliderAnimationStarted = false;
let blogGardenDetailSliderInitialized = false;

function initializeEventListeners() {
  const slider = document.querySelector(".blog-slider");
  if (!slider) return;
  if (blogSliderListenersAttached) return;

  blogSliderListenersAttached = true;

  // Only add drag/touch events - no scroll blocking needed
  slider.addEventListener("touchstart", handleTouchStart);
  slider.addEventListener("touchmove", handleTouchMove);
  slider.addEventListener("touchend", handleTouchEnd);
  slider.addEventListener("mousedown", handleMouseDown);
  slider.addEventListener("dragstart", (e) => e.preventDefault());

  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);
  window.addEventListener("resize", handleResize);
}

// Public API
function initializeSlider(sliderData) {
  if (!sliderData || !Array.isArray(sliderData) || sliderData.length === 0) {
    console.error("Horizontal Slider: Please provide valid slider data");
    return;
  }

  const track = document.querySelector(".blog-slider .slide-track");
  if (!track) {
    console.warn("Horizontal Slider: .blog-slider .slide-track not found");
    return;
  }

  state.sliderData = sliderData;
  state.totalSlideCount = sliderData.length;

  const isBlogGardenDetailNative =
    document.body.classList.contains("blog-garden-mobile") &&
    document.getElementById("blog-garden-detail");

  if (isBlogGardenDetailNative) {
    if (blogGardenDetailSliderInitialized) {
      return;
    }
    blogGardenDetailSliderInitialized = true;
    initializeSlidesBlogGardenNative();
    if (!blogSliderListenersAttached) {
      blogSliderListenersAttached = true;
      window.addEventListener("resize", handleResize);
    }
    blogSliderLastResizeWidth = window.innerWidth;
    return;
  }

  state.blogGardenNative = false;
  state.blogGardenSizeSlides = null;

  initializeSlides();
  initializeEventListeners();

  if (!blogSliderAnimationStarted) {
    blogSliderAnimationStarted = true;
    animate();
  }
}

function tryAutoInitBlogSlider() {
  if (typeof window.blogSliderData === "undefined") return;
  if (!Array.isArray(window.blogSliderData) || window.blogSliderData.length === 0) return;
  initializeSlider(window.blogSliderData);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", tryAutoInitBlogSlider);
} else {
  tryAutoInitBlogSlider();
}

// Export for ES modules
export default function HorizontalSliderLogos(sliderData) {
  initializeSlider(sliderData);
}

// Also make available for direct access
window.HorizontalSliderLogos = { initializeSlider };
